import React from "react";
import "./style.css";

export const Entrar = () => {
  return <h1 className="sign-in">Entrar</h1>;
};
